import React from 'react';
import { toast } from 'react-toastify';
import { ErrorToastify, SuccessToastify } from '../../../assets';
import { getPublicErrorMessage } from '../../../utility/errorMessages';

const CustomToast = ({ logo, message }) => (
  <div className='mx-1 d-flex justify-content-center align-items-center'>
    {logo === 'success' ? (
      <SuccessToastify.default />
    ) : (
      <ErrorToastify.default />
    )}
    <span>{message}</span>
  </div>
);

const Toast = {
  success: (message) =>
    toast(<CustomToast logo='success' message={message} />, { autoClose: 2000 }),
  error: (message) =>
    toast(<CustomToast logo='error' message={getPublicErrorMessage(message)} />, { autoClose: 2000 }),
};

export default Toast;
